<template>
  <el-dialog
    v-if="dialogCreateGroup"
    class="dialogCreateGroup"
    top="10vh"
    :visible.sync="dialogCreateGroup"
    :close-on-click-modal="false"
    width="800px"
    destroy-on-close
    append-to-body
    @close="close">
    <div
      slot="title"
      class="d-flex align-items-center justify-content-between py-3 px-12 border-bottom">
      <span class="fw-700 text-grey900 font-16">Tạo nhóm mới</span>
    </div>

    <div class="">
      <div class="px-12 py-2 border-bottom">
        <el-input
          v-model="groupName"
          size="medium"
          placeholder="Nhập tên nhóm mới" />
      </div>

      <div class="d-flex" style="min-height: 200px;">
        <div class="flex-1 border-right">
          <div class="d-flex align-items-center px-12 bg-base-milk border-bottom">
            <el-input
              class="py-2 me-2"
              size="medium"
              v-model="searchKey"
              @input="searchContact()"
              placeholder="Tìm kiếm" />
            <el-popover
              placement="bottom"
              trigger="click">
              <div class="conversation-box-popover">
                <div class="d-flex align-items-center flex-grow-1 my-1">
                  <div
                    class="radio-button me-3"
                    :class="tagType === 0 && 'radio-button-active'"
                    @click="changeTagOpt(0)">
                    <span>Tất cả ({{ getTagCount(0) }})</span>
                  </div>
                  <div
                    class="radio-button me-3"
                    :class="tagType === 1 && 'radio-button-active'"
                    @click="changeTagOpt(1)">
                    <span>Thẻ chỉ định ({{ getTagCount(1) }})</span>
                  </div>
                  <div
                    class="radio-button"
                    :class="tagType === 2 && 'radio-button-active'"
                    @click="changeTagOpt(2)">
                    <span>Thẻ thường ({{ getTagCount(2) }})</span>
                  </div>
                </div>
                <el-input
                  class="ms-1"
                  placeholder="Tìm kiếm thẻ đã tạo"
                  v-model="searchTagName"
                  size="small"></el-input>
                <div
                  class="d-flex flex-wrap text-center overflow-auto mt-2 px-1"
                  style="max-width: 500px; max-height: 400px; min-width: 500px">
                  <div
                    v-for="(item, index) in listTagView"
                    :key="index">
                    <div
                      class="d-flex pointer"
                      @click="addOrRemoveTag(item)">
                      <TagV2
                        :data="item"
                        :inactive="!isSelected(item)"
                        :item="item"
                        :selected="isSelected(item)"
                        :is-button="true" />
                    </div>
                  </div>
                </div>
              </div>

              <el-tooltip
                slot="reference"
                effect="dark"
                content="Lọc theo tag"
                placement="top">
                <el-button
                  size="small"
                  class="d-flex text-blue500">
                  <div class="d-flex">
                    <span>Lọc theo thẻ đã gắn ({{ selectedTags.length }})</span>
                    <IconV2
                      name="v2-arrow1_drop_down"
                      color="#1769D7" />
                  </div>
                </el-button>
              </el-tooltip>
            </el-popover>
          </div>
          <div class="add-group-contact-scr">
            <div
              v-for="(itemGroup, index) in contactView"
              :key="index">
              <div class="font-14 text-grey600 py-1 px-12 border-bottom border-top bg-base-milk d-flex justify-content-between">
                <span class="fw-700">{{ itemGroup[0].displayName.charAt(0) }}</span>
                <span>{{ itemGroup.length }}</span>
              </div>
              <div
                v-for="contact in itemGroup"
                :key="contact.id"
                class="d-flex align-items-center py-2 px-12">
                <el-checkbox
                  :value="checkSelectedContact(contact.uid)"
                  @change="selectItem(contact)" />
                <el-avatar
                  :size="48"
                  :src="contact.avatar"
                  class="mx-2" />
                <div class="d-flex flex-column justify-content-between">
                  <div
                    style="white-space: normal"
                    class="flex-1 font-size-14 text-1-line text-grey900 fw-700">
                    {{ contact.displayName }}
                    <span
                      v-if="contact.swName"
                      class="font-14 text-grey600 fw-400">
                      | {{ contact.swName }}
                    </span>
                  </div>
                  <ListTagEllipsis
                    v-if="contact.tags.length"
                    class="ms-0 mt-1 mb-0"
                    :tags="contact.tags || []" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-1 px-2">
          <div class="font-size-14 text-grey700 fw-bold mt-1 px-1 d-flex align-items-center justify-content-between">
            <span>Tài khoản đã chọn ({{ items.length }})</span>
            <div
              class="me pointer"
              @click="removeAllItems">
              <IconV2
                name="v2-delete_sweep"
                size="20px" />
            </div>
          </div>
          <div
            v-if="!items.length"
            class="d-flex flex-column flex-grow-1 align-items-center justify-content-center h-100">
            <img src="/assets/images/empty_account.svg" />
            <span class="font-14 text-grey600 mt-2">Chưa có tài khoản nào được chọn</span>
          </div>
          <div
            v-else
            class="add-group-con-scr">
            <div
              class="mt-2 mx-1 rounded-2 d-flex align-items-center justify-content-between"
              style="background-color: rgba(225, 237, 253, 0.6); color: #42444d; width: 300 px; border: thin solid #c2dcff"
              v-for="(contact, index) in items"
              :key="index">
              <div
                class="position-relative rounded-2 d-flex pointer d-flex align-items-center flex-grow-1 py-1"
                @click.stop.prevent="unSelect(contact.id)">
                <el-image
                  :src="contact.avatar"
                  class="ms-1 me-2 img-selected">
                  <div
                    slot="error"
                    class="image-slot">
                    <el-image
                      src="/assets/images/no-avatar.png"
                      class="img-selected"></el-image>
                  </div>
                </el-image>
                <div>
                  <div
                    style="white-space: normal"
                    class="text-1-line font-size-14 text-break me-1">
                    <span>{{ contact.displayName }}</span>
                  </div>
                  <div
                    style="white-space: normal"
                    class="text-1-line font-13 text-grey600 text-break me-1">
                    <span>{{ contact.swName }}</span>
                  </div>
                </div>
              </div>
              <div
                class="me-2 pointer"
                @click.stop.prevent="unSelect(contact.id)">
                <IconV2 name="v2-close" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="divider-custom" />
      <div class="d-flex justify-content-end mx-12 py-12">
        <el-button
          size="md"
          @click="close()">
          Hủy
        </el-button>
        <el-button
          type="primary"
          size="md"
          :disabled="!items.length"
          @click="save()">
          Tạo nhóm
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { groupByName } from "../../lib/text-utils";
import ListTagEllipsis from "../ListTagEllipsis.vue";
import { removeVietnameseTones } from "../../lib/text-utils";
import TagV2 from "../TagV2.vue";

export default {
  props: ["dialogCreateGroup", "conversation", "userId", "accountId"],
  components: { ListTagEllipsis, TagV2 },
  data() {
    return {
      groupName: "",
      contactList: [],
      searchKey: "",
      items: [],
      contactView: [],
      searchTagName: "",
      tagType: 0,
      selectedTags: [],
    };
  },
  computed: {
    listTagView() {
      let view = [];
      switch (this.tagType) {
        case 0: {
          view = this.app.tags;
          break;
        }
        case 1: {
          view = this.app.tags.filter((p) => p.assign);
          break;
        }
        case 2: {
          view = this.app.tags.filter((p) => !p.assign);
          break;
        }
      }

      if (this.searchTagName) {
        view = view.filter(
          (tag) =>
            removeVietnameseTones(tag.name.toLowerCase()).includes(this.searchTagName.toLowerCase()) ||
            tag.name.toLowerCase().includes(this.searchTagName.toLowerCase())
        );
      }

      return view;
    },
  },
  methods: {
    addOrRemoveTag(tag) {
      const index = this.selectedTags.indexOf(tag.id);
      if (index > -1) {
        this.selectedTags.splice(index, 1);
      } else {
        this.selectedTags.push(tag.id);
      }
      this.getAllContact();
    },
    isSelected(tag) {
      let index = this.selectedTags.indexOf(tag.id);
      return index > -1;
    },
    getTagCount(valueOption) {
      switch (valueOption) {
        case 0: {
          return this.app.tags.length;
        }
        case 2: {
          return this.app.tags.filter((t) => !t.assign).length;
        }
        case 1: {
          return this.app.tags.filter((t) => t.assign).length;
        }
        default:
          return 0;
      }
    },
    changeTagOpt(tagType) {
      this.tagType = tagType;
    },
    getMembersId() {
      let items = this.items.map((p) => {
        return p.uid;
      });

      return items;
    },
    save() {
      if (this.groupName.length == 0) {
        this.alert("error", "Nhập tên nhóm.");
        return;
      }
      if (this.items.length < 2) {
        this.alert("error", "Chọn ít nhất 02 người bạn.");
        return;
      }
      let body = {
        groupName: this.groupName,
        accountId: this.accountId,
        membersId: this.getMembersId(),
      };
      this.$http.post("/api/conversation/createGroup", body).then((resp) => {
        this.close();
        if (resp.data.error_code === 270) {
          return this.alert("error", "Bạn đã đạt giới hạn tạo nhóm trong ngày.");
        }
        this.alert("success", "Tạo nhóm thành công");
      });
    },
    searchContact() {
      if (this.searchKey.length > 0) {
        this.contactView = groupByName(
          this.contactList.filter((p) => p.displayName.toLowerCase().includes(this.searchKey.toLowerCase())),
          "displayName"
        );
      } else {
        this.contactView = groupByName(this.contactList, "displayName");
      }
    },

    unSelect(contactId) {
      let filter = this.items.filter((con) => con.id == contactId);
      if (filter != null && filter.length > 0) {
        const index = this.items.indexOf(filter[0]);
        if (index > -1) {
          this.items.splice(index, 1);
        }
      }
    },
    selectItem(contact) {
      let filter = this.items.filter((con) => con.id == contact.id);
      if (filter != null && filter.length > 0) {
        const index = this.items.indexOf(filter[0]);
        if (index > -1) {
          this.items.splice(index, 1);
        }
      } else {
        this.items.push(contact);
      }
    },
    checkSelectedContact(id) {
      let filter = this.items.filter((con) => con.uid == id);
      if (filter != null && filter.length > 0) {
        return true;
      }
      return false;
    },
    getAllContact() {
      this.$http
        .post("/api/contact/filter", {
          searchKey: "",
          accountId: this.accountId,
          selectedTags: this.selectedTags,
        })
        .then((resp) => {
          this.contactList = resp.data.map((c) => ({
            ...c,
            ...c.contact,
            tags: c.tags,
          }));
          if (this.userId) {
            let filter = this.contactList.filter((con) => con.uid == this.userId);
            if (filter != null && filter.length > 0 && !this.items.some((item) => item.uid === this.userId)) {
              this.items.push(filter[0]);
            }
          }
          this.searchContact();
        });
    },
    // setAccountId(id) {
    //   this.accountId = id;
    //   this.getAllContact();
    // },
    removeAllItems() {
      this.items = [];
    },

    close() {
      this.$emit("close", null);
    },
  },
  mounted() {
    this.getAllContact();
  },
};
</script>

<style lang="scss">
.dialogCreateGroup {
  .el-dialog__body {
    padding: 0 !important;
  }
  .el-dialog__header {
    padding: 0 !important;
  }
  .img-selected {
    border: 1px solid #fff;
    width: 36px;
    height: 36px;
    min-width: 36px;
    min-height: 36px;
    border-radius: 18px;
  }
}
</style>